import { useEffect, useState } from "react";
import Layout from "../../../Components/Layout";
import MyOrderList from "../../../Components/OrderMgt/MyOrderList";
import OrderFilter from "../../../Components/OrderMgt/OrderFilter";
import useHttpHook from "../../../Hooks/HttpHook";
import { GetAllOrdersForUser } from "../../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import { OrderLanguage } from "../../../utils/Languages";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const OrderListPage = () => {
  const [, sendRequest, error] = useHttpHook();
  const [orderList, setOrderList] = useState(null);
  const [data, setData] = useState({});

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  useEffect(() => {
    getOrders();
  }, [data]);
  const handleFilterInput = (inputData) => {
    setData(inputData);
  };
  const getOrders = async (page = 1) => {
    try {
      const orders = await sendRequest(GetAllOrdersForUser + "?page=" + page, {
        method: "post",
        data: data,
      });

      if (page === 1) {
        setOrderList(orders);
      } else {
        setOrderList((prevState) => {
          return createObjectForPaginatedResult(orders, prevState, "paginate");
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout
      Heading={OrderLanguage.OrderList.heading}
      TitleMark={true}
      TitleMarkClassName="event-orders-title-mark"
      TitleClassName="event-orders-title"
      HeadClassName="event-orders-head"
      ExtraclassName="event-orders-panel"
      activeMenuId="orders"
    >
      <div className="event-orders-body">
        <OrderFilter handleFilterInput={handleFilterInput} />
        <MyOrderList orderList={orderList} getOrders={getOrders} />
      </div>
    </Layout>
  );
};

export default OrderListPage;
